import React, { useRef } from 'react';
import {
  CategoryCard,
  CategoryCardHeader,
  CategoryCardMedia,
  LinkWithGAPromoClickProps,
} from 'common/components';
import { ProductCategoryCards } from 'common/components/pdp';
import { usePromoViewEvent } from 'common/hooks';
import { withGAPromoClick } from 'common/hocs';
import { enhanceImageUrl } from 'utils';
import { KITCHEN_PRICE_PDP_ELEMENT_BLOCK } from '../../kitchen-price-pdp-constants';
import { useCategoriesListSelector } from './hooks';

const CategoryCardWithGAPromoClick = withGAPromoClick<HTMLAnchorElement, LinkWithGAPromoClickProps>(
  CategoryCard
);

export const CategoryCardSection = () => {
  const cardRefs = useRef<HTMLAnchorElement[]>([]);

  const additionalList = useCategoriesListSelector();

  const promotions = additionalList.map(({ name }, index: number) => ({
    name: `${KITCHEN_PRICE_PDP_ELEMENT_BLOCK}_bottom`,
    creative: name,
    position: (index + 1).toString(),
  }));

  usePromoViewEvent(cardRefs, `${KITCHEN_PRICE_PDP_ELEMENT_BLOCK} / other`, promotions);

  return (
    <ProductCategoryCards
      cardList={additionalList}
      renderCard={({ name, imgSrc, link }, position) => (
        <CategoryCardWithGAPromoClick
          bannerRefs={cardRefs}
          elementBlock={`${KITCHEN_PRICE_PDP_ELEMENT_BLOCK} / other`}
          position={position}
          promotion={promotions[position]}
          {...link}>
          <CategoryCardHeader adaptive={false} title={name} />
          <CategoryCardMedia alt="" height={140} loading="lazy" src={enhanceImageUrl(imgSrc)} width={156} />
        </CategoryCardWithGAPromoClick>
      )}
    />
  );
};
